export default "__VITE_ASSET__BJTgTQc0__"